import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { HomeIntro } from "../components/HomeIntro";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { About } from "../components/About";
import { HomeBlog } from "../components/HomeBlog";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { buildWebPage } from "../components/schema";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Seo
        title="Vetrate Panoramiche VEPA nelle Marche | Vetro Design Italia"
        description="Progettiamo e installiamo vetrate panoramiche VEPA, chiusure in vetro e soluzioni su misura nelle Marche. Preventivo gratuito e senza impegno. Made in Italy."
        path="/"
        jsonLd={buildWebPage("Home · Vetrate panoramiche VEPA nelle Marche", "/", "Progettazione e installazione di vetrate panoramiche VEPA senza profili per terrazzi, balconi e dehor nelle Marche.")}
      />
      <Navbar />
      <Hero />
      <HomeIntro />
      <Services />
      <Portfolio />
      <About />
      <HomeBlog />
      <Contact />
      <Footer />
    </div>
  );
}
